
import { Integration } from '@/types/integrations';
import { createBaseIntegrationService } from './services/baseIntegrationService';
import { createWhatsAppIntegrationService } from './services/whatsappIntegrationService';
import { createDebugService } from './services/debugService';

export const createIntegrationService = (
  setIntegrations: (integrations: Integration[]) => void,
  setIsLoading: (loading: boolean) => void,
  toast: any
) => {
  const baseService = createBaseIntegrationService(setIntegrations, setIsLoading, toast);
  const whatsappService = createWhatsAppIntegrationService(baseService.fetchIntegrations, toast);
  const debugService = createDebugService();

  return {
    ...baseService,
    ...whatsappService,
    ...debugService
  };
};
